import type { MsgDeskLoadingProps } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'

export function MsgDeskLoading({ contract, label = 'Loading', className = '' }: MsgDeskLoadingProps) {
  return (
    <div
      data-md-contract={contract}
      className={`flex min-h-screen w-full items-center justify-center bg-white text-xs font-medium tracking-wide text-slate-500 ${className}`}
      role="status"
      aria-live="polite"
    >
      {label}
    </div>
  )
}
